import React from "react"
import { Link } from "react-router-dom"
import { Navigation, Pagination, Autoplay, A11y } from "swiper"

import { Swiper, SwiperSlide } from "swiper/react"

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/scrollbar"
import constants from "../../lib/constants"
import PubSub from "pubsub-js"

function HomeContentPicText({ banners, requireLogin = false  }) {

  const doubleBanner = (banners) => {
    let ret = []
    for (let index = 0; index < banners.length; index += 2) {
      const dBanner = [banners[index]];
      if (banners[index+1]) {
        dBanner.push(banners[index+1])
      }
      ret.push(dBanner)
    }
    return ret
  }
  
  const bannerTag = (banner) => {
    return <Link className="mb-3 d-block" to={banner.link??'/'} key={banner.id} onClick={handleClick}>
    <div className="d-flex">
      <div className="banner-pictext_pic">
        <img src={`${constants.imageBaseUrl}/${banner.image}`} alt="" />
      </div>
      <div className="banner-pictext_text">
        <h3>{banner.title}</h3>
        <p>{banner.description}</p>
      </div>
    </div>
  </Link>  
  }

  const handleClick = (e) => {
    if (requireLogin) {
      e.preventDefault()
      PubSub.publish("REQUIRE_LOGIN", e.target.to)
    }
  }  
  return (
    <Swiper
      className="banner-content"
      modules={[Navigation, Pagination, Autoplay, A11y]}
      spaceBetween={50}
      slidesPerView={1}
      loop={false}
      autoplay={false}
      // autoplay={{
      //   delay: 10000,
      //   disableOnInteraction: false,
      // }}
      speed={800}
      pagination={{ clickable: true }}
    >
      {doubleBanner(banners).map((dBanner, index) => (
        <SwiperSlide key={index}>
          {
            dBanner.map(db => bannerTag(db))
          }
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

export default HomeContentPicText
